import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { windowLocation } from '../util/url';

export default function (ComposedComponent) {
  class RequireManageBilling extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      windowLocation() && windowLocation().replace(to + windowLocation().search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      if (!this.props.user.permissions) {
        this.redirect('/');
        return null;
      }

      if (!this.props.user.permissions.manageBilling) {
        const location = windowLocation();
        if (location && location.search && location.search.includes('from=insights')) {
          this.redirect('/no-manage-billing');
          return null;
        }

        this.redirect('/');
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequireManageBilling);
}
